import React, { useEffect, useMemo, useRef, useState, useImperativeHandle } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleUp } from "@fortawesome/free-solid-svg-icons"

import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'

import { TABLE_DATA } from "util";

import update from 'immutability-helper'

import Rows from "./DnDTables/DataTable";

import ModalPortal from "util/component/Modal";
import { Confirm } from "util/component/Modal/Modal";

import { useTranslation } from 'react-i18next'

const P_TYPE = "composition";
const API = "";
const initialData = TABLE_DATA[P_TYPE].filter(t => t.type !== "hidden");

const COMTable = (props, _ref) => {
    const { t } = useTranslation(['page']);
    const { PROCode, unitCd, onOpen, RevCmptCheckList, remarkList, updateRemarkList } = props;

    const [Hide, setHide] = useState(false);
    const [ModalOpen, SetModalOpen] = useState(false);
    const [TData, setTData] = useState([]);
    const modalData = useRef({ modalType: null });

    useImperativeHandle(_ref, () => ({
        getTableData: () => {
            return TData;
        },
        initial: () => {
            setTData(TD => []);
        },
        add: () => {
            // setTData(TP => update(TP, {
            //     $push: [initialData]
            // }))
        },
        move: ({ dragIndex, hoverIndex }) => {
            // setTData(TP => update(TP, {
            //     $splice: [
            //         [dragIndex, 1],
            //         [hoverIndex, 0, TP[dragIndex]],
            //     ]
            // }))
        },
        remove: (idx) => {
            setTData(TP => update(TP, {
                $splice: [[idx, 1]]
            }));
        },
        loadData: ({data}) => {
            let newVal = [];
            let tmp;
            let fidx;
            data.forEach(d => {
                tmp = TABLE_DATA[P_TYPE];
                Object.keys(d).forEach(k => {
                    fidx = tmp.findIndex(i => i.name === k);
                    if (fidx > -1) tmp = update(tmp, {
                        [fidx]: { $merge: { value: d[k] } }
                    })
                })
                newVal = [...newVal, [...tmp]]
            })
            setTData(newVal);
        }
    }))

    // urs 63 : 카피기능 추가 (카피 안되는 현상 해결
    // const copyRow = (code, index) => {
    //     setTData((TP) =>
    //         update(TP, {
    //             $push: [TData[index]],
    //         })
    //     );
    // };
    const copyRow = (code, index) => {
        const newArr = JSON.parse(JSON.stringify(TData[index]));
        newArr.forEach((f) => {
            if (f.name === "uniqueCode") {
                f.value = "";
            }
            if (f.name === "interfaceCode") {
                f.value = "";
            }
        });
        setTData((TP) =>
            update(TP, {
                 $push: [newArr] 
            })
        );
    };

    const updateRemarkListRow = (idx,data,type)  => {
        updateRemarkList(idx,data,type);
    };

    // urs 63 카피 끝
    const onOpenWrapper = (vv,uniqueCode) => {
        onOpen(vv,uniqueCode,TData,'COM');
    }
    const HandleHide = () => {
        setHide(!Hide);
    }


    const addRow = () => {
        setTData(TP => update(TP,
            { $push: [initialData] }
        ))
    }

    const changeRow = (code, idx, idx2, obj) => {
        setTData(TP => update(TP,
            {
                [idx]: {
                    [idx2]: { $merge: { ...obj } }
                }
            }
        ))

    }
    const changeRemark = (uniqueCode,value,remarkCnt,oldValue) => {
            TData.forEach((row, i) =>{
                row.forEach((tData,ii)=>{
                    if(tData.name === 'uniqueCode'  &&uniqueCode.findIndex((d) => d && d === tData.value) !== -1){
                        setTData(TP => update(TP,
                            {
                                [i]: {
                                    [row.findIndex((d) => d.name ==='remark')]: { $merge: { ...value } }
                                }
                            }
                        ))
                    }else if(tData.name === 'remark'  && uniqueCode.findIndex((d) => (d === undefined || d === '')) !== -1  && tData.value === oldValue){
                        setTData(TP => update(TP,
                            {
                                [i]: {
                                    [row.findIndex((d) => d.name ==='remark')]: { $merge: { ...value } }
                                }
                            }
                        ))
                    }


                })

            })

    }


    const moveRow = (code, dragIndex, hoverIndex) => {
        setTData(TP => update(TP,
            {
                $splice: [
                    [dragIndex, 1],
                    [hoverIndex, 0, TP[dragIndex]],
                ],
            }
        ))

    }

    const modalRender = () => {
        return <Confirm onClose={() => SetModalOpen(false)} onConfirm={() => deleteRowConfirm()}>
            <p>{t("delete")}</p>
        </Confirm>
    }
    const modal = useMemo(modalRender, [ModalOpen])

    const deleteRow = (code, index) => {
        modalData.current = { index };
        SetModalOpen(true);
    }
    const deleteRowConfirm = () => {
        const { index } = modalData.current;

        setTData(TP => update(TP,
            {

                $splice: [[index, 1]]
            }
        ))
        SetModalOpen(false);
    }

    const [newRemarkList,setNewRemarkList] = useState({});
    useEffect(() => {

        //const t = newRemarkList?.filter(item => item.remark.includes(e.target.innerText.toString().trim()) );
        const tableRemarkList=remarkList.filter(item => item.name === "com");
        //const sortRemarkList=[...new Set(tableRemarkList.map( x =>x.remark))];
        let remarkData = [];
        tableRemarkList.sort().forEach((d,i) => {

            if (remarkData.findIndex((newData) => newData.value === d.value) === -1) {
                remarkData.push({value:d.value,oldValue:d.value,uniqueCode :[d.uniqueCode]});
            }else if(remarkData.findIndex((newData) => newData.value === d.value && newData.uniqueCode !== d.uniqueCode) !== -1){
                // remarkData = [remarkData,]
                remarkData.forEach((data,i) => {
                    if(data.value === d.value){
                        data.uniqueCode.push(d.uniqueCode);
                    }

                })
            }



        });
        setNewRemarkList(remarkData);
    }, [remarkList]);
    const removeClass = (className) =>{
        document.querySelectorAll('.'+className).forEach(e =>{
            e.classList.remove(className)
        })
    }
    const renderFunc = () => {

        try {
            return TData.map((v, i) => {                
                return <Rows
                    api={API}
                    // code={k.tempUniqCode}
                    copied={copyRow}
                    PROCode={PROCode}
                    index={i}
                    rowData={v}
                    moveRow={moveRow}
                    changed={changeRow}
                    deleted={deleteRow}
                    key={"comp" + i}
                    onOpen = {onOpenWrapper}
                    RevCmptCheckList={RevCmptCheckList}
                    tableType={"comp"}
                    remarkList={newRemarkList}
                    setRemarkList = {setNewRemarkList}
                    changeRemark = {changeRemark}
                    updateRemarkListRow={updateRemarkListRow}
                    removeClass = {removeClass}
                />
            })
        } catch (e) {
            return null;
        }
    }

    return unitCd?.match(/(USP01|DSP01|USP06|DSP07)/) !== null &&
    // return false && 
        <section className="create" style={{width: "initial"}}>
        <div className={"in_table tbl_box " + (Hide ? "hide" : "")}>
            <h1 className={"title "} onClick={HandleHide}>{P_TYPE.toUpperCase()} <FontAwesomeIcon icon={faAngleUp} /></h1>
            <div className={"data_table "}>
                <DndProvider backend={HTML5Backend}>
                    <table>
                        <colgroup>
                            <col width="2%"></col>
                             {/*<col width="10%"></col>*/}
                            <col width="10%"></col>
                            <col width="10%"></col>
                            <col width="10%"></col>
                            <col width="10%"></col>
                            <col width="2%"></col>
                            <col width="0.5%"></col>
                            <col width="2%"></col>
                            <col width="12%"></col>
                            <col width="2%"></col>
                            <col width="1%"></col>
                        </colgroup>
                        <thead>
                            <tr>
                                <th></th>
                                 {/*<th>Parameter Code</th>*/}
                                <th>Material Code</th>
                                <th>Component</th>
                                <th>Main/Alter</th>
                                <th>Concentration</th>
                                <th colSpan="3">Unit</th>
                                <th>Reference</th>
                                <th>Remark</th>
                            </tr>

                        </thead>
                        <tbody>
                            {renderFunc()}
                        </tbody>
                        <tfoot>
                            {
                                <tr className="add_param" onClick={addRow}>
                                    <td colSpan={Object.keys(initialData).length + 1}>+Add Parameter</td>
                                </tr>
                            }

                        </tfoot>
                    </table>
                </DndProvider>
            </div>
        </div>
        {ModalOpen &&
            <ModalPortal>
                {modal}
            </ModalPortal>
        }
    </section>
}

export default React.memo(React.forwardRef(COMTable));